module.exports = __webpack_public_path__ + "static/media/MTGif.70804f7e.gif";